import React, { Component } from 'react';
import { withRouter } from 'react-router';

import CategoryList from 'components/reports/CategoryList';
import ReportsListDisplay from 'components/reports/ReportsListDisplay';
import SurveyTemplateApi from 'apis/SurveyTemplate';
import CategoryReportApi from 'apis/reports/CategoryReport';
import Loading from 'utils/Loading';

class Reports extends Component {
  constructor() {
    super();

    this.state = {
      categories: [],
      report: [],
      loaded: false,
      startDate: null,
      endDate: null,
    };

    this.fetchCategories = this.fetchCategories.bind(this);
    this.fetchReport = this.fetchReport.bind(this);
    this.fetchCategoryName = this.fetchCategoryName.bind(this);
    this.setName = this.setName.bind(this);
    this.changeReportRange = this.changeReportRange.bind(this);
  }

  componentWillMount() {
    this.fetchCategories();
    this.fetchReport();
    this.fetchCategoryName();
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const { startDate, endDate } = this.state;

    if (location !== prevProps.location) {
      startDate && endDate
        ? this.fetchReport(startDate.unix(), endDate.unix())
        : this.fetchReport();
    }
  }

  fetchCategories() {
    SurveyTemplateApi.getAll()
      .then(({ data }) => {
        this.setState({ categories: data, loaded: true });
      })
      .catch(e => console.log(e));
  }

  changeReportRange(startDate, endDate) {
    const { startDate: prevStartDate, endDate: prevEndDate } = this.state;
    if ((prevStartDate || prevEndDate) && !startDate && !endDate) {
      this.fetchReport();
    }

    this.setState(
      (state, props) => ({
        startDate,
        endDate,
      }),
      () => {
        if (startDate && endDate) {
          this.fetchReport(startDate.unix(), endDate.unix());
        }
      }
    );
  }

  fetchReport(from, to) {
    const { match } = this.props;
    const { params } = match;

    if (params.id) {
      CategoryReportApi.getAll(params.id, from, to)
        .then(({ data }) => {
          this.setState({ report: data });
        })
        .catch(e => console.log(e));
    }
  }

  fetchCategoryName() {
    const { match } = this.props;
    const { params } = match;

    if (params.id) {
      SurveyTemplateApi.getDetails(params.id)
        .then(({ data }) => this.setState({ name: data.name }))
        .catch(e => console.log(e));
    }
  }

  setName(name) {
    this.setState({ name });
  }

  render() {
    const { match } = this.props;
    const { params } = match;
    const categoryId = params.id;
    const $initialDisplay = categoryId ? (
      <ReportsListDisplay
        showDateFilter
        report={this.state.report}
        fetchReport={this.fetchReport}
        changeReportRange={this.changeReportRange}
        disableShareReport
        startDate={this.state.startDate}
        endDate={this.state.endDate}
      />
    ) : (
        <div className="question-welcome">Select a survey to display reports</div>
      );
    if (!this.state.loaded) {
      return <Loading />;
    }
    return (
      <div className="container">
        <h3 className="mt-4 mb-4 text-truncate">{this.state.name}</h3>
        <div className="row">
          <div className="col-md-3">
            <CategoryList categories={this.state.categories} setName={this.setName} />
          </div>
          <div className="col-md-9">{$initialDisplay}</div>
        </div>
      </div>
    );
  }
}

export default withRouter(Reports);



// WEBPACK FOOTER //
// ./src/containers/Reports.js